/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaUiAPauseIcon24Solid = forwardRef('MediaUiAPauseIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M8.5 4A1.5 1.5 0 0 0 7 5.5v13a1.5 1.5 0 0 0 3 0v-13A1.5 1.5 0 0 0 8.5 4Z" }),
        React.createElement("path", { d: "M15.5 4A1.5 1.5 0 0 0 14 5.5v13a1.5 1.5 0 0 0 3 0v-13A1.5 1.5 0 0 0 15.5 4Z" })));
});
